<template>
    <transition>
        <div class="forget-container-inner">
            <h4 class="forget-title">{{$t('forget_passwd')}}</h4>
            <p class="forget-subtitle">{{$t('input_send_email')}}</p>
            <el-form
                :model="formData"
                :rules="formRules"
                ref="formRef"
                @submit.native.prevent="confirm"
            >
                <el-form-item prop="account">
                    <el-input type="email" v-model="formData.account" :placeholder="$t('email')"></el-input>
                </el-form-item>
                <button class="form-btn">{{$t('confirm')}}</button>
            </el-form>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            formData: {
                account: ""
            },
            formRules: {
                account: [
                    {
                        required: true,
                        message: this.$t("email_error"),
                        trigger: "none"
                    },
                    {
                        type: "email",
                        message: this.$t("email_error"),
                        trigger: "none"
                    }
                ]
            }
        };
    },
    methods: {
        confirm() {
            this.$refs["formRef"].validate(valid => {
                if (!valid) {
                    // this.$message('请检查您的表单', 'error')
                    return;
                }
                this.$req
                    .post("retsendemailcode", {
                        account: this.formData.account
                    })
                    .then(resp => {
                        if (resp.data.code === "2000") {
                            this.$msg.success(this.$t("msg_send_success"));
                            this.$store.dispatch("updateForgetFlow", {
                                show: false,
                                type: this.$store.getters.forgetFlow.type
                            });
                            this.resetFields();
                        } else {
                            this.$msg.error(resp.data.msg);
                        }
                    });
            });
        },
        resetFields() {
            this.$refs["formRef"].resetFields();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/Public/Forget/Email.vue